import { colors } from '@lmc/common/constants'
import { isBrowser, isTablet } from 'react-device-detect'
import styled from 'styled-components'

export const BodyText = styled.div`
  line-height: 22px;
`

export const Container = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  margin: auto;
  max-width: 960px;
`

export const Footer = styled.div`
  && {
    background: white;
    border: none;
    display: flex;
    justify-content: center;
    width: ${isBrowser || isTablet ? 'calc(100vw - 290px)' : '100vw'};
  }
`

export const FooterSubContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  width: 960px;
`

export const GreyBodyText = styled.div`
  color: ${colors.darkgrey};
  padding-right: 16px;
`

export const Header = styled.h2`
  align-self: center;
  line-height: 36px;
  margin-bottom: 24px;
`
